import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Tabs } from 'antd';
import routes from 'src/routes';
import { useApplicationDataCleansingParams } from 'src/hooks/useApplicationParams';
import { Application } from 'src/constants/application.const';
import { HomeTab, ConfigurationTab, DataCleansingTab, DataEditorTab, StatusTab, QualityAssuranceTab } from './tabs';
import styles from './OpsCenterView.module.less';

const { TabPane } = Tabs;

export type TabPaneKey =
  | '/nucleus/home'
  | '/nucleus/configuration'
  | '/nucleus/dataCleansing'
  | '/nucleus/dataEditor'
  | '/nucleus/status'
  | '/nucleus/qa';

const defaultTabKey = HomeTab.key;

const OpsCenterView: React.FC = () => {
  const history = useHistory();
  const location = window.location.pathname;
  const [activeKey, setActiveKey] = useState<TabPaneKey>(defaultTabKey);
  const [
    {
      isRaDataCleanup,
      isRaProductCleanup,
      isRaShallowCleanup,
      isRaSpiderCleanup,
      isRaDataEditor,
      isRaDiagnostic,
      isEM,
      isStreamingSys,
      isSysStatus,
      isRaClientMng,
      isRaMatchAttMng,
      isRaSiteMng,
      isAnonAdmin
    },
  ] = useApplicationDataCleansingParams(Application.Nucleus.id);

  const isConfiguration = Boolean(isAnonAdmin || isRaClientMng || isRaMatchAttMng || isRaSiteMng);
  const isDataCleansing = Boolean(isRaDataCleanup || isRaProductCleanup || isRaShallowCleanup || isRaSpiderCleanup);
  const isStatus = Boolean(isStreamingSys || isSysStatus);
  const isQaTabEnabled = Boolean(isEM);
  const [isNucleusMsg, setIsNucleusMsg] = useState<boolean | null>(true); // null means loading
  const [__loading, setLoading] = useState<boolean>(true);

useEffect(() => {
  const timer = setTimeout(() => {
    const computedIsNucleusMsg = Boolean(
      isAnonAdmin ||
        isRaClientMng ||
        isRaMatchAttMng ||
        isRaSiteMng ||
        isRaDataCleanup ||
        isRaProductCleanup ||
        isRaShallowCleanup ||
        isRaSpiderCleanup ||
        isStreamingSys ||
        isSysStatus ||
        isEM ||
        isRaDiagnostic ||
        isRaDataEditor
    );
    setIsNucleusMsg(computedIsNucleusMsg);
    setLoading(false);
  }, 1000);
  return () => clearTimeout(timer);
}, [
  isAnonAdmin,
  isRaClientMng,
  isRaMatchAttMng,
  isRaSiteMng,
  isRaDataCleanup,
  isRaProductCleanup,
  isRaShallowCleanup,
  isRaSpiderCleanup,
  isStreamingSys,
  isSysStatus,
  isEM,
  isRaDiagnostic,
]);
  useEffect(() => {
    if (location === routes.optCenter) {
      history.push({ pathname: defaultTabKey });
    }
    setActiveKey(location as TabPaneKey);
  }, [location]);

  useEffect(() => {
    const nucleusApps = [
      { path: '/nucleus/qa', flag: isQaTabEnabled },
      { path: '/nucleus/dataEditor', flag: isRaDataEditor },
      { path: '/nucleus/configuration', flag: isConfiguration },
      { path: '/nucleus/dataCleansing', flag: isDataCleansing },
      { path: '/nucleus/status', flag: isStatus },
    ];

    if (nucleusApps.some(({ path, flag }) => location.startsWith(path) && flag === false)) {
      history.push({ pathname: defaultTabKey });
    }
  }, [isQaTabEnabled, isRaDataEditor, isConfiguration, isDataCleansing, isStatus]);

  const handleTabChange = (key: string) => {
    history.push({ pathname: key });
  };

  return (
    <Tabs activeKey={activeKey} className={styles.opsCenterTabs} onChange={handleTabChange}>
      {isNucleusMsg ? (
        <TabPane tab={HomeTab.header} key={HomeTab.key}>
          {isRaDiagnostic && <HomeTab.Content isRaDiagnostic={isRaDiagnostic} />}
        </TabPane>
      ) : (
        <TabPane tab={HomeTab.header} key={HomeTab.key}>
          <span>Please enable atleast one privilege under nucleus on your account to display sub-menus.</span>
        </TabPane>
      )}
      {isConfiguration && (
        <TabPane tab={ConfigurationTab.header} key={ConfigurationTab.key} className={styles.confiTabPane}>
          <ConfigurationTab.Content
            isAnonAdmin={isAnonAdmin}
            isRaClientMng={isRaClientMng}
            isRaMatchAttMng={isRaMatchAttMng}
            isRaSiteMng={isRaSiteMng}
          />
        </TabPane>
      )}
      {isDataCleansing && (
        <TabPane tab={DataCleansingTab.header} key={DataCleansingTab.key}>
          <DataCleansingTab.Content
            isRaDataCleanup={isRaDataCleanup}
            isRaProductCleanup={isRaProductCleanup}
            isRaShallowCleanup={isRaShallowCleanup}
            isRaSpiderCleanup={isRaSpiderCleanup}
          />
        </TabPane>
      )}
      {isRaDataEditor && (
        <TabPane tab={DataEditorTab.header} key={DataEditorTab.key}>
          <DataEditorTab.Content isRaDataEditor={isRaDataEditor} />
        </TabPane>
      )}
      {isStatus && (
        <TabPane tab={StatusTab.header} key={StatusTab.key}>
          <StatusTab.Content isStreamingSys={isStreamingSys} isSysStatus={isSysStatus} />
        </TabPane>
      )}

      {isQaTabEnabled && (
        <TabPane tab={QualityAssuranceTab.header} key={QualityAssuranceTab.key}>
          <QualityAssuranceTab.Content isEM={isEM} />
        </TabPane>
      )}
    </Tabs>
  );
};

export default OpsCenterView;
